import { apiDelete, apiListAll, apiPost } from '@/core/api/resources'
import { me } from './session'
import { descriptionFor } from '@/variants'
import type { Stage } from '@/core/types'
import { trackSettingsWrite } from '@/core/api/settingsWrites'

export async function listCoachStatusSicht(): Promise<Stage[]> {

  const { organisationId, variant } = await me()
  const { stageForStatusName } = descriptionFor(variant)
  const rows = await apiListAll('/coach_status_sicht', {
    organisation_id: organisationId,
    include: ['status'],
  })
  return rows
    .map((r) => stageForStatusName(r.status?.name))
    .filter((s): s is Stage => s !== null)
}

export async function listCoachVisibleStatusIds(): Promise<Set<string>> {
  const { organisationId } = await me()
  const rows = await apiListAll('/coach_status_sicht', { organisation_id: organisationId })
  return new Set(rows.map((r) => r.status_id))
}

export function setCoachStatusVisible(statusId: string, visible: boolean): Promise<void> {
  return trackSettingsWrite(async (identity) => {
    const { organisationId } = await me()
    if (visible) {
      await apiPost('/coach_status_sicht', { organisation_id: organisationId, status_id: statusId }, identity)
    } else {
      await apiDelete('/coach_status_sicht/{organisation_id}/{status_id}', {
        organisation_id: organisationId,
        status_id: statusId,
      }, identity)
    }
  })
}
